<template lang="pug">
  .container-winners
    .container
      .title-players-green GANADORES
      .tabs
        ul
          li(@click="setOption(month.id)"
            :class="{ 'is-active' : month.status }"
            :key="month.id"
            v-for="(month, index) in months")
              a {{ month.name }}
      .base-players(v-if="winner")
        .overflow-player.fade-in
          .players
            .player
              span.name {{ winner.nombre }}
              .data-attr
                span
                  b Matrícula
                  span {{ winner.matricula }}
                span
                  b NIT
                  span {{ winner.identificacion }}
                span
                  b Fecha de Renovación
                  span {{ $root.formatDate(winner.fecharenovacion) }}
      .empty-players(v-else)
        .fade-in
          span {{ emptyPlayersText }}
      .info-terms(v-if="winner") ¡Es el ganador en el mes de {{ month_text }} de un viaje todo pago a {{ month_text=='Enero' ? 'San Andrés' : 'Cartagena' }} para dos personas!
      .info-terms(v-else) ¡Animate, en el mes de {{ month_text }} podrías ser el ganador un viaje todo pago a {{ month_text=='Enero' ? 'San Andrés' : 'Cartagena' }} para dos personas!
      .columns(v-if="month_text=='Enero'")
        .column.image-beach.andr
        .column.text-beach.andr
      .columns(v-else)
        .column.image-beach.cart
        .column.text-beach.cart
</template>

<script>
export default {
  data() {
    return {
      months: [
        { id: 0, name: 'Enero', status: true },
        { id: 1, name: 'Febrero', status: false },
        { id: 2, name: 'Marzo', status: false },
      ],
      code: 'REN_GAN_ENERO_2020',
      month_text: 'Enero',
      winner: {}
    }
  },
  computed: {
    emptyPlayersText() {
      let vm = this
      if (vm.$root.sending)
        return 'Cargando...'
      else
        return `No hay ningun ganador para el mes de ${vm.month_text} aún.`
    }
  },
  methods: {
    setOption(o) {
      let vm = this
      if (o != vm.actual_tab_id) {
        const f = _.find(vm.months, function (m) {
          return m.id == o
        })
        vm.resetStatusTabs()
        f.status = true
        vm.caseSelector(o)
        vm.getWinners()
      }
    },
    resetStatusTabs() {
      let vm = this
      _.forEach(vm.months, function(m) {
        m.status = false
      })
    },
    caseSelector(o) {
      let vm = this
      switch (o) {
        case 0:
          vm.code = 'REN_GAN_ENERO_2020'
          vm.month_text = 'Enero'
          break
        case 1:
          vm.code = 'REN_GAN_FEBRERO_2020'
          vm.month_text = 'Febrero'
          break
        case 2:
          vm.code = 'REN_GAN_MARZO_2020'
          vm.month_text = 'Marzo'
          break
        default:
          vm.code = 'CODE_NOT_ASSIGNED'
          break
      }
    },
    getWinners() {
      let vm = this
      vm.$root.sending = !vm.$root.sending
      axios.get(`/api/concursos/${vm.code}/getWinner`)
      .then(function (response) {
        vm.$root.sending = !vm.$root.sending
        vm.winner = response.data.data
      })
      .catch(function (error) {
        vm.$root.sending = !vm.$root.sending
        console.log(error)
      })
    }
  },
  mounted() {
    this.getWinners()
  }
}
</script>

<style lang="sass" scoped>
  .title-players-green
    letter-spacing: 3px
    font-family: "Montserrat-Black"
    background: linear-gradient(to top, #07b987 , #9eb237)
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
    text-align: center
    margin-bottom: 1em
    font-size: 3rem
    font-weight: bold
  .tabs ul
    border: none!important
    li
      position: relative
    a 
      font-family: "Montserrat-Regular"
      color: #9e9e9e!important
    .is-active
      a
        color: #505050!important
      &:after
        content: ''
        position: absolute
        bottom: 0
        left: 0
        z-index: -1
        height: 1px
        width: 100%
        background: linear-gradient(to right, #ffae04, #00bb86)
  .player
    border: 1px solid rgba(95, 102, 156, 0.48)
    border-radius: 20px
    color: purple
    margin-bottom: 15px
    width: 100%
    & .data-attr
      padding: 2px 0
      display: flex
      justify-content: space-around
      align-items: center
      & span
        font-size: 13px
        font-family: "Montserrat-Light"
        background: radial-gradient(circle farthest-corner at 200px 0,#6971b1,#555b8e)
        -webkit-background-clip: text
        -webkit-text-fill-color: transparent
    & span
      padding: 5px 10px
      &.name
        font-family: "Montserrat-LightItalic"
        letter-spacing: 2px
        display: -webkit-box
        -webkit-font-smoothing: antialiased
        -webkit-line-clamp: 1
        -webkit-box-orient: vertical
        overflow: hidden
        border-top-right-radius: 20px
        border-top-left-radius: 20px
        border-bottom: 1px solid
        text-align: center
        font-weight: bold
        background: radial-gradient(circle farthest-corner at 200px 0, #6971b1, #555b8e)
        color: #fff
        font-size: 1.5rem
  .container-winners
    //background: #fff
    position: relative
    //transform: translateY(-120px) skewY(-5deg)
    //border-bottom: 10px solid #FFB216
    padding: 0em 20px 3em 20px
    &:after, &:before
      width: 220px
      height: 220px
      position: absolute
      background-size: cover !important
      background-repeat: no-repeat !important
      background-position: center !important
      z-index: -1
    &:after
      content: ''
      top: -172px
      left: 0
      background: #fff
      width: 100%
      height: 173px
      opacity: 1
  .columns
    margin: 0px 80px
  .info-terms
    font-family: "Montserrat-LightItalic"
    font-weight: 300
    font-size: 1rem
    text-align: center
    margin-top: 40px
  .text-beach
    margin: 20px 10px
    height: 200px
    background-repeat: no-repeat
    background-position: left
    background-size: contain
    &.andr
      background-image: url(../../../images/assets2020/destinos-01.svg)
    &.cart
      background-image: url(../../../images/assets2020/destinos-02.svg)
  .image-beach
    margin: 20px 10px
    height: 200px
    background-repeat: no-repeat
    background-position: right
    background-size: contain
    transition: .3s 
    &.andr
      background-image: url(../../../images/assets2020/destinos-01.png)
      &:hover,&:focus
        filter: drop-shadow(5px 5px 10px rgba(0,0,0,.3))
        transform: rotate(10deg) scale(1.5)
    &.cart
      background-image: url(../../../images/assets2020/destinos-02.png)
      &:hover,&:focus
        filter: drop-shadow(5px 5px 10px rgba(0,0,0,.3))
        transform: rotate(10deg) scale(1.5)
</style>



// WEBPACK FOOTER //
// resources/js/components/PageConcurso2020/WinnersConcurse.vue